export default __webpack_public_path__ + "static/media/Pray-1.bf2af409.svg";